
export const root = {
    gap: '1.125rem'
};

export const controls = {
    gap: '0.5rem'
};

export default {
    root,
    controls
};
